import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import UpdateGalleryForm from "../../../Components/Forms/UpdateGalleryForm";
import ActionBar from "../../../Components/Button/ActionBar";

export default function Gallery() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id, album_code } = location.state || {};
  const [image, setImage] = useState<File[]>([]);
  const [image_name, setImageName] = useState<any>();
  const [album_image, setImageAlbum] = useState<File | null>(null);
  const [post_date, setPostDate] = useState("");
  const [event_date_end, setEventDateEnd] = useState("");
  const [event_date_start, setEventDateStart] = useState("");
  const [folder_name, setFolderName] = useState("");
  const [album_name, setAlbumName] = useState("");
  const [albumCode, setAlbumCode] = useState(album_code || "");
  const [slug, setSlug] = useState("");
  const [category, setCategory] = useState("");
  const [isPermanent, setIsPermanent] = useState<boolean>(false);
  const [postID, setPostID] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [album_image_name, setAlbumImageName] = useState("");
  const [warningMessage, setWarningMessage] = useState<string>("");

  // const MAX_FILE_SIZE_MB = 30;

  const isValidTextFormat = (format: string) => /^[A-Za-z0-9-]+$/.test(format);

  const handleFolderNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;

    if (isValidTextFormat(newName) || newName === "") {
      setFolderName(e.target.value);
    }
  };

  const handlePostDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostDate(e.target.value);
  };

  const handleEventDateStartChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEventDateStart(e.target.value);
  };

  const handleEventDateEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEventDateEnd(e.target.value);
  };

  const handleAlbumNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAlbumName(e.target.value);
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCategory(e.target.value);
  };

  const handleIsPermanentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsPermanent(e.target.checked);
  };

  const handleAlbumCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAlbumCode(e.target.value);
  };

  const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;

    if (isValidTextFormat(newName) || newName === "") {
      setSlug(newName);
    }
  };
  const handleImageAlbum = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setImageAlbum(e.target.files[0]);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      // const totalSize = selectedFiles.reduce(
      //   (total, file) => total + file.size,
      //   0
      // );

      // // Convert total size to MB
      // const totalSizeInMB = totalSize / (1024 * 1024);

      // // Check if the total size exceeds the limit
      // if (totalSizeInMB > MAX_FILE_SIZE_MB) {
      //   setWarningMessage(
      //     `Warning: You can only upload up to ${MAX_FILE_SIZE_MB} MB of images. The selected files exceed this limit.`
      //   );
      // } else {
      //   setWarningMessage("");
      //   setImage(selectedFiles);
      // }
        setWarningMessage("");
        setImage(selectedFiles);
    }
  };

  useEffect(() => {
    if (id) fetchItem(id, album_code);
  }, [id]);

  useEffect(() => {
    setRole(localStorage.getItem("role"));
  }, []);

  const fetchItem = async (id: number, album_code: string) => {
    try {
      const response = await axios.get(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/gallery/${id}?album_code=${album_code}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      const { folder_details: gallery, Images } = response.data;
      if (gallery) {
        setPostDate(gallery.post_date || "");
        setFolderName(gallery.folder_name || "");
        setAlbumName(gallery.album_name || "");
        setAlbumCode(gallery.album_code || "");
        setSlug(gallery.slug || "");
        setAlbumImageName(gallery.album_image || "");
      }
      setImageName(Images || []);
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("post_date", post_date);
    formData.append("album_name", album_name);
    formData.append("album_code", albumCode);
    formData.append("slug", slug);

    // Append album image, check if it's null
    if (album_image) {
      formData.append("album_image", album_image);
    } else {
      formData.append("album_image", album_image_name); // When no new album image is provided, use the existing one
    }

    // Append additional images if provided
    if (image.length > 0) {
      image.forEach((img, index) => formData.append(`image[${index}]`, img));
    }

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) throw new Error("Authentication token not found!");

      let response;

      if (!id) {
        // Create a new gallery
        response = await axios.post(
          `https://cdn.pulp.ph/api/v1/pulpliveworld/gallery`,
          formData,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );
      } else {
        // Update the existing gallery
        response = await axios.post(
          `https://cdn.pulp.ph/api/v1/pulpliveworld/gallery/${id}`,
          formData,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );
      }

      alert("Content Submitted Successfully!");
      navigate("/view/post/gallery");
    } catch (error: any) {
      // Log and handle the error
      console.error(
        "Error submitting form:",
        error.response ? error.response.data : error.message
      );
      alert("Error Encountered. Please Contact IT");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (!id) return;
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this content?"
    );
    if (!confirmDelete) return;

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) throw new Error("Authentication token not found!");

      await axios.delete(
        `https://stagingbackend.pulp.ph/api/v1/shortStory/${id}`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      alert("Content Deleted Successfully!");
      navigate("/view/post/Show");
    } catch (error) {
      console.error("Error deleting content:", error);
      alert("Error deleting content!");
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  const handleViewShortstory = async () => {
    try {
      if (postID) {
        window.open(`https://cdn.com/article/${postID}`, "_blank");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="w-full">
      <div className="Dashboard-container flex place-content-between">
        <h1 className="mt-5 font-semibold">Gallery Editor</h1>
        <ActionBar
          role={role}
          onView={handleViewShortstory}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          isSaved={isSubmitting}
        />
      </div>
      <div className="container mt-5 pt-5 px-4 rounded bg-white">
        <UpdateGalleryForm
          image={image}
          album_image={album_image}
          onImageChange={handleImageChange}
          onAlbumImageChange={handleImageAlbum}
          post_date={post_date}
          event_date_end={event_date_end}
          event_date_start={event_date_start}
          category={category}
          isPermanent={isPermanent}
          warningMessage={warningMessage}
          slug={slug}
          folder_name={folder_name}
          album_code={album_code}
          album_name={album_name}
          onSlugChange={handleSlugChange}
          onPostDateChange={handlePostDateChange}
          onFolderNameChange={handleFolderNameChange}
          onAlbumCodeChange={handleAlbumCodeChange}
          onAlbumNameChange={handleAlbumNameChange}
          onCategoryChange={handleCategoryChange}
          onEventDateEndChange={handleEventDateEndChange}
          onEventDateStartChange={handleEventDateStartChange}
          onIsPermanentChange={handleIsPermanentChange}
        />
      </div>
    </div>
  );
}
